<div class="row p-b-10">
    <div class="col-xs-12 col-sm-8">
        <h4 class="page-title">{{TR "Statistik"}}</h4>
    </div>
    {{#if hasColumns}}
    <div class="col-xs-12 col-sm-4">
        <div class="pull-right">
            <div class="btn-group pull-right">
                <a class="btn btn-default js-stats-save-perm">
                    <i class="fa fa-sitemap"></i>
                </a>
                <a class="btn btn-default js-stats-add">
                    <i class="fa fa-plus"></i>
                </a>
                <a class="btn btn-default js-stats-refresh">
                    <i class="fa fa-refresh"></i>
                </a>
            </div>
        </div>
    </div>
    {{/if}}
</div>

<div class="row">
    <div {{#unless hasColumns}}class="col-xs-12"{{/unless}}>
        <div id="value-list"></div>
    </div>
</div>

<div class="row p-b-10">
    <div class="col-xs-12 col-sm-8">
        <h4 class="page-title">{{TR "Geräteauswahl"}}</h4>
    </div>
</div>
<div class="row">
    <div class="col-sm-12">
        <div class="card-box clearfix">
            <div class="row js-stats-info">
                <div class="m-t-5 col-xs-12 col-md-12">
                    <div class="alert alert-info js-stats-info-select-cat">
                        {{TR 'Bitte wählen Sie mindestens eine Gerätekategorie aus.'}}
                    </div>
                    <div class="alert alert-danger js-stats-info-combine-cat">
                        {{TR 'Virtuelle und physische Geräte können nicht kombiniert werden.'}}
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12">
                    <div id="device-filter"></div>
                </div>
            </div>
            <a data-toggle="collapse" href="#device-select">
                {{TR "Geräteauswahl anpassen"}}
            </a>
        </div>
    </div>
</div>

<div class="row">
    <div id="device-select-error">
    </div>
</div>

<div class="row">
    <div class="col-xs-12">
        <div id="device-select" class="collapse"></div>
    </div>
</div>
